import { Locale } from 'modules/domains/template';
import { Trans } from 'services/i18n';
import { BannerVariants } from 'ui/banner/types';
import { InfoFill } from 'ui/icons';
import { Nullish } from 'utils/tsHelpers';
import { useTranslations } from '../../../hooks/useTranslations';
import { DEFAULT_LOCALE_SELECT_TEST_IDS } from '../DefaultLocaleSelectFormField.constants';
import { StyledBanner } from '../DefaultLocaleSelectFormField.styled';

export const DifferentSelectedDefaultLocaleThanProjectBanner = ({
  selectedDefaultLocale,
}: {
  selectedDefaultLocale: Nullish<Locale>;
}) => {
  const { t } = useTranslations();

  return (
    <StyledBanner
      Icon={<InfoFill width={16} height={16} />}
      data-test={DEFAULT_LOCALE_SELECT_TEST_IDS.bannerSpecialDefault}
      variant={BannerVariants.INFO}
    >
      <Trans
        t={t}
        i18nKey="banner.specialDefaultLocale"
        components={{
          bold: <strong />,
          paragraph: <p />,
        }}
        values={{
          languageName: selectedDefaultLocale?.languageName,
          tag: selectedDefaultLocale?.tag,
        }}
      >
        <p>
          You’ve selected a locale default that is different from your project default. When a
          campaign is sent using this template, Iterable will fall back to{' '}
          <strong data-test="locale">
            {selectedDefaultLocale?.languageName} {selectedDefaultLocale?.tag}
          </strong>{' '}
          if there is no localized content for a user’s locale at send time.
        </p>
      </Trans>
    </StyledBanner>
  );
};
